import React from "react";
import DefaultCard from "./default-card";

import ucaEnv from "../../../../common/env/env-uca";
import { useApi } from "../../../../hooks";
import { CommonModule } from "uca-react-containers-library";

const getButtonTitle = (data) => {
  const { subscriptionStatus: status } = data;
  switch (status) {
    case "ACTIVE":
    case "SUSPENDED":
    case "CANCELLED":
    case "PROCESSING":
    case "TRIAL":
      return "Manage Subscription";

    default:
      return "Start Free Trial";
  }
};

const FreshPassCard = ({ category, banner, isGuest }) => {
  let apiResponse;
  if (!isGuest) {
    const {
      appData: { env, platform },
    } = CommonModule.useApp();
    const environmentVariables = ucaEnv(banner, env, platform);
    const { data } = useApi(
      `${environmentVariables.REWARDS_PAGE_BASE_API}/customer/subscription`
    );
    apiResponse = data;
  }

  return (
    <DefaultCard
      category={{
        ...category,
        desc: !isGuest
          ? apiResponse
            ? apiResponse.message || "Signup for a free trial"
            : "Signup for a free trial"
          : category.desc
      }}
      shrinkable={true}
    />
  );
};

export default FreshPassCard;
